import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import CommonModal from "../../../CommonComponents/Modal/CommonModal";
import PdfOpener from "../../../CommonComponents/Modal/PdfOpener";
import CommonButton from "../../../CommonComponents/CommonButton";
import { images } from "../../../Images/Svg";
import style from "../../CaseManagement/Actions/UploadDoucument/UploadDocument.module.css";
import InvestigationActionButtons from "./InvestigationActionButtons";
import Approval from "../../CaseManagement/Actions/Approval";
import {
  InvestigationButtonLabels,
  truncateMiddleText,
  typeOfAudio,
  typeOfPlayer,
} from "../../../Utils/helper";
import useToaster from "../../../customHook/useToaster";
import AudioPlayer from "../../../CommonComponents/Player/AudioPlayer";
import VideoPlayer from "../../../CommonComponents/Player/VideoPlayer";
import TableGrid from "../../../CommonComponents/TableGridView/TableGrid";
import { invoiceDetails } from "../../../constants/approvalsData";
import { Fragment } from "react";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import ReactPanZoom from "react-image-pan-zoom-rotate";
import DocxOpener from "../../../CommonComponents/Modal/DocxOpener";
const { AodbeIcon } = images;
//truncate function
const truncateMiddle = (str, maxLength) => {
  if (str.length <= maxLength) {
    return str;
  }
  const firstPart = str.substr(0, maxLength / 2);
  const lastPart = str.substr(str.length - maxLength / 2);
  return `${firstPart}.....${lastPart}`;
};

function InvestigationInvoice({
  invoiceData,
  onActionSubmit,
  firstTabVal,
  tabStatus,
  isAssignedToCurrentUser,
}) {
  const [invoices, setInvoices] = useState({});
  // const [openPreviewModal, setOpenPreviewModal] = useState(false);
  const [openActionModal, setOpenActionModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState({});
  const [selectedPopup, setSelectedPopup] = useState("");
  const [remark, setRemark] = useState("");
  const [docIndex, setDocIndex] = useState(0);
  const { showToast } = useToaster();
  const invoiceClickHandler = (key, data) => {
    // setSelectedInvoice({
    //   name: data?.document_name,
    //   path: data?.document_path,
    // });
    let {
      charge_details = [],
      invoice_details = null,
      invoice_documents = [],
    } = data;

    if (
      selectedInvoice?.[key]?.invoice_details?.invoice_master_id ===
      invoice_details?.invoice_master_id
    ) {
      setSelectedInvoice({});
      return;
    }

    let tax_details = {
      cgst: invoice_details?.cgst || "0.00",
      sgst: invoice_details?.sgst || "0.00",
      ugst: invoice_details?.ugst || "0.00",
      total: invoice_details?.total_gst || "0.00",
    };
    setSelectedInvoice({
      [key]: {
        invoice_details: {
          ...invoice_details,
          charge_details,
          tax_details,
        },
        invoice_documents,
      },
    });
    // setOpenPreviewModal(true);
    setDocIndex(0);
  };
  const buttonClickHandler = (event, popupType) => {
    if (
      popupType === InvestigationButtonLabels[1] ||
      popupType === InvestigationButtonLabels[2]
    ) {
      setOpenActionModal(true);
      setRemark("");
    } else {
      onActionSubmit({
        type: popupType,
      });
    }
    setSelectedPopup(popupType);
  };

  const submitHandler = () => {
    if (
      // selectedPopup === InvestigationButtonLabels[2] &&
      !remark
    ) {
      // return showToast("Please provide remark for rejection.", "info", true);
      return showToast("Please provide remark to submit.", "info", true);
    }
    onActionSubmit({
      type: selectedPopup,
      remark,
      setOpenActionModal,
    });
  };

  const previousDoc = () => {
    if (docIndex > 0) setDocIndex((prevIndex) => prevIndex - 1);
  };

  const nextDoc = (key) => {
    if (docIndex < selectedInvoice?.[key]?.invoice_documents?.length - 1)
      setDocIndex((prevIndex) => prevIndex + 1);
  };

  const isAssigned =
    typeof isAssignedToCurrentUser === "undefined"
      ? true
      : isAssignedToCurrentUser;
  useEffect(() => {
    let updatedInvoiceData = {
      updated: {
        label: "Updated Invoices",
        docs: [],
        info: null,
      },
      prevUploaded: {
        label: "Previously Uploaded Invoices",
        docs: [],
        info: null,
      },
      approvedUploaded: {
        label: "Approved Invoice",
        docs: [],
        info: null,
      },
    };

    if (invoiceData) {
      let prevData = invoiceData?.previousInvoicesDetails || [];
      // let prevInfo = invoiceData?.invoiceInformation?.previous_invoice_info;
      let updatedData = invoiceData?.freshInvoicesDetails || [];
      // let updatedInfo = invoiceData?.invoiceInformation?.fresh_invoice_info;
      let approvedData = invoiceData?.approvedInvoicesDetails || [];
      updatedInvoiceData?.prevUploaded?.docs?.push(...prevData);
      updatedInvoiceData?.updated?.docs?.push(...updatedData);
      updatedInvoiceData?.approvedUploaded?.docs?.push(...approvedData);
      // updatedInvoiceData.prevUploaded.info = prevInfo;
      // updatedInvoiceData.updated.info = updatedInfo;
    }

    setInvoices({ ...updatedInvoiceData });
    setSelectedInvoice({});
  }, [invoiceData]);

  return (
    <div className={style["main-container_invoice"]}>
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          gap: "12px",
        }}
      >
        {invoiceData?.freshInvoicesDetails?.length ? (
          !["Invoice", "Hospital", "Garage"].includes(firstTabVal) ? (
            <InvestigationActionButtons
              onClick={buttonClickHandler}
              hideButton={
                invoiceData?.hideActionButtoninvoiceStatus !== "review" ||
                tabStatus === "closed" ||
                firstTabVal === "Submitted" ||
                !isAssigned
              }
            />
          ) : null
        ) : (
          ""
        )}
      </div>

      <div className={style["invoice-container"]}>
        {Object.keys(invoices).map((key) =>
          invoices[key]?.docs?.length ? (
            <Fragment>
              <div key={key} className={style["map-container_invoice"]}>
                <h2>{invoices[key]?.label}</h2>
                <div className={style["main-conatiner-div"]}>
                  {invoices[key]?.docs?.map((doc, index) => (
                    <div
                      key={`${key}-${index}-`}
                      className={style["file-conatiner_invoice"]}
                      onClick={() => invoiceClickHandler(key, doc)}
                      style={{
                        boxShadow:
                          selectedInvoice?.[key]?.invoice_details
                            ?.invoice_master_id &&
                          doc?.invoice_details?.invoice_master_id ===
                            selectedInvoice?.[key]?.invoice_details
                              ?.invoice_master_id
                            ? "0px 4px 4px 0px #00000040"
                            : "unset",
                      }}
                    >
                      <div className={style["Uploadimage-div"]}>
                        <img src={AodbeIcon} alt="AodbeIcon" />
                        <div>
                          <p
                            style={{ fontSize: "1.2rem", fontWeight: 500 }}
                          >{`Invoice ${index + 1}`}</p>
                          {/* <p>{truncateMiddleText(doc?.document_name, 10)}</p>
                          <p className={style["fileSize"]}>
                            {doc?.document_size}
                          </p> */}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {selectedInvoice?.[key]?.invoice_details && (
                <div style={{ marginTop: "14px", width: "143%" }}>
                  <TableGrid
                    gridContent={selectedInvoice?.[key]?.invoice_details || {}}
                    backgroundColor="#FFFFFF"
                    boxShadow="0px 5px 25px rgba(0, 0, 0, 0.06)"
                    invoice={true}
                  />
                  {selectedInvoice?.[key]?.invoice_documents && (
                    <div style={{ margin: "20px auto", width: "75%" }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            color: "#737D8C",
                            alignSelf: "center",
                            display: "flex",
                            fontSize: "1.6rem",
                            fontWeight: 700,
                          }}
                        >
                          <KeyboardArrowLeft
                            sx={{
                              fontSize: "2.6rem",
                              cursor: "pointer",
                              color: docIndex === 0 ? "#8F949B" : "#3A3A3A",
                            }}
                            onClick={previousDoc}
                          />
                          <span style={{ margin: "0 1rem" }}>
                            {" "}
                            {`Displaying ${docIndex + 1} of ${
                              selectedInvoice?.[key]?.invoice_documents?.length
                            } uploades`}
                          </span>
                          <KeyboardArrowRight
                            sx={{
                              fontSize: "2.6rem",
                              cursor: "pointer",
                              color:
                                docIndex ===
                                selectedInvoice?.[key]?.invoice_documents
                                  ?.length -
                                  1
                                  ? "#8F949B"
                                  : "#3A3A3A",
                            }}
                            onClick={() => nextDoc(key)}
                          />
                        </Typography>
                      </Box>
                      <Box sx={{ marginTop: "2rem" }}>
                        {selectedInvoice?.[key]?.invoice_documents?.[
                          docIndex
                        ]?.document_name
                          ?.split(".")
                          ?.pop() === "pdf" ||
                        selectedInvoice?.[key]?.invoice_documents?.[
                          docIndex
                        ]?.document_name
                          ?.split(".")
                          ?.pop() === "PDF" ? (
                          <PdfOpener
                            pdfFileLink={
                              selectedInvoice?.[key]?.invoice_documents?.[
                                docIndex
                              ]?.document_path
                            }
                          />
                        ) : selectedInvoice?.[key]?.invoice_documents?.[
                            docIndex
                          ]?.document_name
                            ?.split(".")
                            ?.pop() === "docx" ? (
                          <DocxOpener
                            fileName={
                              selectedInvoice?.[key]?.invoice_documents?.[
                                docIndex
                              ]?.document_path
                            }
                            fileType={selectedInvoice?.[
                              key
                            ]?.invoice_documents?.[docIndex]?.document_name
                              ?.split(".")
                              ?.pop()}
                          />
                        ) : typeOfPlayer?.includes(
                            selectedInvoice?.[key]?.invoice_documents?.[
                              docIndex
                            ]?.document_name
                              ?.split(".")
                              ?.pop()
                          ) ? (
                          <VideoPlayer
                            src={
                              selectedInvoice?.[key]?.invoice_documents?.[
                                docIndex
                              ]?.document_path
                            }
                            type={selectedInvoice?.[key]?.invoice_documents?.[
                              docIndex
                            ]?.document_name
                              ?.split(".")
                              ?.pop()}
                          />
                        ) : typeOfAudio?.includes(
                            selectedInvoice?.[key]?.invoice_documents?.[
                              docIndex
                            ]?.document_name
                              ?.split(".")
                              ?.pop()
                          ) ? (
                          <AudioPlayer
                            src={
                              selectedInvoice?.[key]?.invoice_documents?.[
                                docIndex
                              ]?.document_path
                            }
                            type={selectedInvoice?.[key]?.invoice_documents?.[
                              docIndex
                            ]?.document_name
                              ?.split(".")
                              ?.pop()}
                          />
                        ) : selectedInvoice?.[key]?.invoice_documents?.[
                            docIndex
                          ]?.document_path ? (
                          <div
                            style={{ position: "relative", overflow: "hidden" }}
                          >
                            <ReactPanZoom
                              alt="invoiceImg"
                              image={
                                selectedInvoice?.[key]?.invoice_documents?.[
                                  docIndex
                                ]?.document_path
                              }
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      </Box>
                    </div>
                  )}
                </div>
              )}
            </Fragment>
          ) : (
            ""
          )
        )}
      </div>

      <CommonModal
        showCrossIcon={false}
        open={openActionModal}
        onClose={() => setOpenActionModal(false)}
      >
        <Approval
          message={
            selectedPopup === InvestigationButtonLabels[1]
              ? "Are you sure you want to approve?"
              : selectedPopup === InvestigationButtonLabels[2]
              ? "Are you sure you want to reject?"
              : "Are you sure?"
          }
          onClick={(action) => setOpenActionModal(action)}
          isRemark={true}
          // isRemarkRequired={selectedPopup === InvestigationButtonLabels[2]}
          isRemarkRequired={true}
          remarkVal={remark}
          onChange={(e) => setRemark(e?.target?.value)}
          onSubmit={submitHandler}
        />
      </CommonModal>

      {/* <CommonModal
        open={openPreviewModal}
        showCrossIcon={true}
        width="45%"
        height="90%"
        onClose={() => setOpenPreviewModal(false)}
        showDownloadIcon={true}
        downloadFilePath={selectedInvoice?.path}
        downloadFileName={selectedInvoice?.name}
      > */}

      {/* </CommonModal> */}
    </div>
  );
}

export default InvestigationInvoice;
